import React from "react";
import { Company, JobListing as JobType } from "@lib/types/jobTypes";
import { Avatar } from "@mantine/core";
import Link from "next/link";
import getJobUrl from "@lib/utils/url/getJobUrl";
import dynamic from "next/dynamic";
import { ExternalLink } from "react-feather";
import FatUnderlined from "@components/Various/FatUnderlined";

const SmallJobCard = dynamic(
  () => import("@components/JobListing/SmallJobCard")
);

function CompanyListing({
  company,
  jobs,
}: {
  company: Company;
  jobs: JobType[];
}) {
  return (
    <div className="flex items-center flex-col mb-12 p-5">
      <div className="max-w-4xl">
        <div className="flex items-center flex-col">
          {company.logo && (
            <Avatar
              src={company.logo as string}
              alt={company.name}
              className="rounded-full"
              size="xl"
            />
          )}
          <h1 className="text-3xl font-bold mb-6">
            <FatUnderlined>{company.name}</FatUnderlined>
          </h1>
          <p className="text-slate-500 text-sm max-w-2xl">
            {company.description}
          </p>
          {company.website && (
            <a
              href={company.website}
              className="text-blue-500 flex items-center"
              target="_blank"
              rel="noreferrer"
            >
              <ExternalLink className="mr-1" size={15} /> {company.website}
            </a>
          )}
        </div>
        <h2 className="text-xl font-bold mt-12 mb-6">
          Jobs von {company.name}
        </h2>

        <div className="flex flex-col items-center gap-3">
          {jobs.map((job) => (
            (<Link
              key={job.id}
              href={getJobUrl(job, false)}
              className="min-w-[80vw] max-w-[70vw] md:min-w-[50vw] md:max-w-[50vw]">

              <SmallJobCard job={job} />

            </Link>)
          ))}
        </div>
      </div>
    </div>
  );
}

export default CompanyListing;
